export function RiskBadge({ level = "medium" }) {
  const map = {
    low: { label: "Established", cls: "text-emerald-300 bg-emerald-500/10 border-emerald-500/20" },
    medium: { label: "Growing", cls: "text-gold bg-gold/10 border-gold/25" },
    high: { label: "Emerging", cls: "text-rose-300 bg-rose-500/10 border-rose-500/20" },
  };
  const c = map[level] || map.medium;
  return (
    <span data-testid="risk-badge" className={`inline-flex items-center gap-1.5 text-[0.65rem] uppercase tracking-wider px-2.5 py-1 rounded-full border ${c.cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" /> {c.label}
    </span>
  );
}

export function RiskMeter({ level = "medium", showLabel = true }) {
  const map = {
    low: { fill: 2, color: "#34D399", label: "Conservative" },
    medium: { fill: 3, color: "#D4AF37", label: "Balanced" },
    high: { fill: 5, color: "#FB7185", label: "Aggressive" },
  };
  const cfg = map[level] || map.medium;
  return (
    <div data-testid="risk-meter" className="flex flex-col gap-2">
      <div className="flex items-center gap-1.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <span key={i} className="h-1.5 flex-1 rounded-full transition-all"
            style={{ backgroundColor: i <= cfg.fill ? cfg.color : "rgba(255,255,255,0.1)" }} />
        ))}
      </div>
      {showLabel && (
        <div className="flex items-center justify-between">
          <span className="text-[0.6rem] uppercase tracking-widest" style={{ color: cfg.color }}>{cfg.label}</span>
          <span className="text-[0.6rem] uppercase tracking-widest text-ebg-muted">{level} risk</span>
        </div>
      )}
    </div>
  );
}
